<template>
    <div class="addActivity">
        <div class="mbx clearfix">
            <el-breadcrumb class="fl" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>活动印花</el-breadcrumb-item>
                <el-breadcrumb-item>添加页面</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="文件上传" :label-width="formLabelWidth">
                    <el-upload class="upload-demo" :action="url" :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="uploadSuccedd" :multiple="true" show-file-list list-type="picture" :before-upload="beforeAvatarUpload">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">文件大小不能超过2M</div>
                    </el-upload>

                </el-form-item>
            </el-form>
            <div class="button">
                <el-button type="primary" @click="onSubmit('form')">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { addActivityImgs } from '../api/api.js'
    export default {
        name: 'addActivity',
        data() {
            return {
                url: this.GLOBAL.uploderPicURL,
                form: {
                    title: '',
                    companyNewsImg: ''
                },
                formLabelWidth: '100px',
                rules: {
                    title: [
                        { required: true, message: '请输入标题', trigger: 'blur' }
                    ]
                }
            }
        },
        mounted() {

        },
        methods: {
            handleRemove(file, fileList) {
                this.$message.warning(`成功删除文件，请重新选取文件`);
                this.form.companyNewsImg = ''
                for (let i = 0; i < fileList.length; i++) {
                    this.companyNewsImg += fileList[i].response.data.filePath + ',';
                }
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            // 图片上传成功钩子
            uploadSuccedd(file, fileList) {
                this.form.companyNewsImg += file.data.filePath + ',';
            },
            onSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.form.companyNewsImg = this.form.companyNewsImg.slice(0, this.form.companyNewsImg.length - 1);
                        addActivityImgs(this.form).then((res) => {
                            if (res.status === 1) {
                                this.$refs[formName].resetFields();
                                this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                this.$router.push({ path: '/ht_activity' });
                            }
                        });
                    } else {

                        return false;
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .mbx {
        background-color: #f5f5f5;
        padding: 1% 4%;
    }

    .content {
        width: 50%;
    }

    .button {
        text-align: center
    }
</style>



// WEBPACK FOOTER //
// src/components/ht_addactivity.vue